export const FOCUS_RING =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-2';

const LINK_BUTTON_BASE =
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors duration-150 cursor-pointer';

export const LINK_BUTTON_PRIMARY = `${LINK_BUTTON_BASE} px-6 py-3 text-lg font-semibold bg-chocolate-dark text-white hover:bg-chocolate-deep active:bg-chocolate-deep ${FOCUS_RING}`;

export const LINK_BUTTON_GHOST = `${LINK_BUTTON_BASE} min-h-11 px-4 py-2 text-base text-chocolate hover:bg-champagne active:bg-champagne-dark ${FOCUS_RING}`;
